import EyelashCalculator from "../components /calculate/Calculate"
import Sillabuses from "../components /Sillabus/Sillabus"
import styles from "./ThirdScreen.module.css"
const ThirdScreen=()=><>

    <div className={styles.title}>יאללה! הגיע הזמן לצלול עמוק..</div>
    <div className={styles.description}>שני קורסים ייחודיים שעוצבו ונבנו במיוחד עבורך, כל אחד והיתרונות שלו - ככה זה הולך לעבוד:</div>

    <Sillabuses/>
   
</>
export default ThirdScreen